import React from "react";
import Button from "../../components/Button";
import Cancel from "../../icons/Cancel";
import AdvancedText from "../../components/AdvancedText";
import { privacy } from "../../locales/ko/privacy";
import { typography } from "../../styles/typography";
import colors from "../../styles/colors";

const DataDeletion = () => {

    return (
        <div style={styles.container}>
            <div style={{ ...styles.subcontainer, color: '#fff' }}>
                <div style={styles.header}>
                    <Button style={styles.cancel} onClick={() => window.close()}>
                        <Cancel />
                    </Button>
                    <label style={styles.label} className="title_s_18_medium mt-16">Eyary Data Deletion</label>
                    <div style={styles.divider} />
                </div>
                <p>To delete your account follow these steps:</p>
                <ol>
                    <li>Press the menu button at the top left of the <b>Home Screen</b></li>
                    <li>Press [Edit Profile] in the <b>Settings</b> screen</li>
                    <li>Press [Delete Account] at the bottom of <b>Edit Profile</b> screen</li>
                    <li>Check the <b>"I understand all data will be deleted"</b> checkbox and press [Delete Account]</li>
                    <li>After authenticating with your password, press [Delete Account]</li>
                    <li>The deletion process will start and a confirmation screen will be shown</li>
                </ol>
                <h3>*Warning!</h3>
                <p>This irrevocable process will delete all your personal data and nothing will be retained.</p>
            </div>
        </div>
    )
}


const styles = {
    container: {
        position: 'absolute',
        background: '#070E10',
        display: 'flex',
        width: '100%',
        height: '100dvh',
        overflow: 'hidden'
    },
    header: {
        display: 'flex',
        flexDirection: 'column'
    },
    subcontainer: {
        marginTop: 20,
        background: "#1C2226",
        flex: 1,
        width: '100%',
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        display: 'flex',
        flexDirection: 'column',
        padding: 14

    },
    cancel: {
        alignSelf: "flex-end"
    },
    label: {
        color: '#fff'
    },
    divider: {
        backgroundColor: '#23292E',
        height: '1px',
        width: '100%',
        marginTop: 24,
        marginBottom: 24
    },
    content: {
        ...typography.body["14_regular"],
        color: colors.mono400,
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'scroll'
    },
}

export default DataDeletion